<template>
  <div class="d d_xm">
    <headers :goBack="goBack" :isForm="1" />
    <van-form
      @submit="onClickButtonSubmit"
      validate-trigger="onBlur"
      @failed="handleFailed"
      ref="formRef"
    >
      <div class="kuang">
        <div class="official-document">
          <div class="official-heading">提示：</div>
          <p class="official-paragraph">1. 凡涉及到填写数字、姓名等重要项目，填写第一遍后会出现弹窗提示，需再次填写确认。</p>
          <p class="official-paragraph">2. “手机号”仅能输入11位，“身份证号”仅能输入18位，“学校（机构）代码”仅能输入10位。均需输入两遍确认。</p>
          <p class="official-paragraph">3. “所学专业大类”按所授予学位证书进行选择，若没有学位证书则按毕业证书上所学专业的大类来选择。</p>
          <p class="official-paragraph">4. 本系统填报各统计项数据截止到2025年12月31日。</p>
        </div>
        <div style="padding: 4px 15px; font-size: 16px;">
           <a
              :href="shuoming"
              download="2025年度队统填报说明.pdf"
              style="color: #ff6865; text-decoration: underline"
              >2025年度队统填报说明.pdf</a
            >
            <br>
            <a
              :href="fujian1"
              download="附件1队统填报问答.pdf"
              style="color: #ff6865; text-decoration: underline"
              >附件1队统填报问答.pdf</a
            >
            <br>
            <a
              :href="fujian2"
              download="附件2队统后台使用手册.pdf"
              style="color: #ff6865; text-decoration: underline"
              >附件2队统后台使用手册.pdf</a
            >
            <br>
            <a
              href="https://weibo.com/tv/show/1034:5277095408894029?from=old_pc_videoshow"
              target="_blank"
              style="color: #ff6865; text-decoration: underline"
              >队统教学视频（学校使用）</a
            >
        </div>
        <!-- 是否配备少先队总辅导员 -->
        <van-field
          required
          name="radio"
          label="是否配备少先队总辅导员"
          class="radioFlex fieldVertical"
          :rules="[{ required: true, message: '请选择是否配备少先队总辅导员' }]"
        >
          <template #input>
            <van-radio-group v-model="isEquippedCounselor" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        
        <!-- 1-6. 行政区划 -->
        <van-field
          v-model="areaTxt"
          required
          readonly
          clickable
          label="行政区划"
          placeholder="请选择行政区划"
          @click="showAreaPopup"
          :rules="[{ required: true, message: '请选择行政区划' }]"
        />
        <van-popup v-model:show="areaShow" position="bottom">
          <van-picker
            title="请选择行政区划"
            :columns="areaColumns"
            @confirm="onAreaConfirm"
            @cancel="areaShow = false"
            @change="onAreaChange"
          />
        </van-popup>

        <template v-if="isEquippedCounselor == 1">
          <!-- 1-1. 姓名 -->
          <van-field
          class="fieldVertical"
            required
            v-model="name"
            clearable
            label="姓名"
            placeholder="请输入姓名"
            :rules="[
              { required: true, message: '请填写姓名' },
              { validator: validateName, label: '姓名' },
            ]"
          />
          <van-field
          class="fieldVertical"
            required
            v-model="nameConfirm"
            clearable
            label="确认姓名"
            placeholder="请再次输入姓名"
            :rules="[
              { required: true, message: '请再次填写姓名' },
              {
                validator: (val) => val === name,
                message: '两次输入的姓名不一致',
              },
              { validator: validateName, label: '确认姓名' },
            ]"
          />

          <!-- 1-2. 身份证号 -->
          <van-field
            required
            v-model="idCard"
            clearable
            label="身份证号"
            placeholder="请输入身份证号"
            maxlength="18"
            :rules="[
              { required: true, message: '请输入身份证号' },
              {
                pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                message: '身份证号格式错误',
              },
            ]"
            @blur="handleDoubleCheck('idCard', '身份证号')"
            class="fieldVertical"
          />
          <van-field
            required
            v-model="idCardConfirm"
            clearable
            label="确认身份证号"
            placeholder="请再次输入身份证号"
            maxlength="18"
            :rules="[
              { required: true, message: '请再次填写身份证号' },
              {
                validator: (val) => val === idCard,
                message: '两次输入的身份证号不一致',
              },
            ]"
            class="fieldVertical"
          />

          <!-- 1-3. 性别 -->
          <van-field
            required
            name="radio"
            label="性别"
            class="radioFlex"
            :rules="[{ required: true, message: '请选择性别' }]"
          >
            <template #input>
              <van-radio-group v-model="sex" direction="horizontal">
                <van-radio :name="1" checked-color="#ff6865">男</van-radio>
                <van-radio :name="2" checked-color="#ff6865">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>

  <!--        &lt;!&ndash; 1-4. 出生年月 &ndash;&gt;-->
  <!--        <datetime-picker-->
  <!--          :value="birthday"-->
  <!--          title="出生年月"-->
  <!--          type="year-month"-->
  <!--          :callback="(val) => handlerSelect('birthday', val)"-->
  <!--          :isRequired="birthdayFlag"-->
  <!--        />-->

          <!-- 年龄 -->
          <van-field
            :model-value="age ? age + '岁' : ''"
            readonly
            label="年龄"
            placeholder="根据身份证号自动生成"
          />

          <!-- 1-5. 手机号 -->
          <van-field
            class="fieldVertical"
            required
            v-model="tel"
            clearable
            label="总辅导员手机号"
            placeholder="请输入总辅导员手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入总辅导员手机号' },
              { pattern: /^1[3456789]\d{9}$/, message: '手机号格式错误' },
            ]"
            @blur="handleDoubleCheck('tel', '手机号')"
          />
          <van-field
            class="fieldVertical"
            required
            v-model="telConfirm"
            clearable
            label="确认总辅导员手机号"
            placeholder="请再次输入总辅导员手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请再次填写总辅导员手机号' },
              {
                validator: (val) => val === tel,
                message: '两次输入的手机号不一致',
              },
            ]"
          />

          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="政治面貌"
            :rules="[{ required: true, message: '请选择政治面貌' }]"
          >
            <template #input>
              <van-radio-group v-model="zzmm" direction="vertical">
                <van-radio
                  v-for="item in zzmmList01"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>

        <!-- 2-1. 总辅导员级别 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="总辅导员级别"
          :rules="[{ required: true, message: '请选择总辅导员级别' }]"
        >
          <template #input>
            <van-radio-group v-model="fdyLevel" direction="vertical">
              <van-radio
                v-for="item in fdyLevList"
                :key="item.key"
                :name="item.key"
                checked-color="#ff6865"
              >
                {{ item.value }}
              </van-radio>
            </van-radio-group>
            <div
              style="
                font-size: 16px;
                color: #999;
                margin-top: 8px;
                line-height: 1.4;
              "
            >
              *直辖市的区县按“县、市、区、旗”级别来选
            </div>
          </template>
        </van-field>

        <!-- 2-2. 上传图片 (地市级/县级) -->
        <div v-if="(fdyLevel == 2 || fdyLevel == 3) && isEquippedCounselor == 1">
          <van-field
            class="fieldVertical"
            name="uploader"
            label="上传少先队总辅导员本人聘书或任命文件的图片"
            required
            :rules="[{ required: true, message: '请上传少先队总辅导员本人聘书或任命文件的图片' }]"
          >
            <template #input>
              <van-uploader
                v-model="fileList"
                :max-count="1"
                :after-read="afterRead"
                 @click-preview="handlePreview"
              />
            </template>
          </van-field>
          <div style="font-size: 12px; color: #999; padding: 0 16px 10px">
            聘书或任命文件的图片应为PNG或JPG格式，尺寸不低于1024*768，公章清晰、内容完整。无上述文件的由同级团委开具证明，
            <a
              :href="proofFile"
              download="证明模板.docx"
              style="color: #ff6865; text-decoration: underline"
              >证明模板</a
            >
          </div>
        </div>

        <!-- 2-3. 下辖乡镇总辅导员数量 (县级) -->
        <div v-if="fdyLevel == 3 ">
          <van-field
            required
            v-model="townCounselorNum"
            clearable
            type="digit"
            label="本县（市、区、旗）下辖乡镇（街道）总辅导员数量"
            placeholder="请输入数量（没有填0） "
            :rules="[{ required: true, message: '请输入数量' },{
                validator: (val) => val >= 0 && val <= 100,
                message:
                  '本县（市、区、旗）下辖乡镇（街道）总辅导员数量必须在0-100之间',
              },]"
            @blur="
              handleCountCheck(
                'townCounselorNum',
                '本县（市、区、旗）下辖乡镇（街道）总辅导员数量',
                100,
              )
            "
            class="fieldVertical"
          />
          <van-field
            required
            v-model="townCounselorNumConfirm"
            clearable
            type="digit"
            label="确认本县（市、区、旗）下辖乡镇（街道）总辅导员数量"
            placeholder="请再次输入数量"
            :rules="[
              {
                required: true,
                message:
                  '请再次输入本县（市、区、旗）下辖乡镇（街道）总辅导员数量',
              },
              {
                validator: (val) => val === townCounselorNum,
                message: '两次输入的数量不一致',
              },
            ]"
            class="fieldVertical"
          />
        </div>

        <!-- 3-1. 本级是否有红领巾巡讲团 -->
        <van-field
          required
          name="radio"
          label="本级是否有红领巾巡讲团"
          class="radioFlex fieldVertical"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <template #input>
            <van-radio-group v-model="hasRedScarfGroup" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 3-2. 本级红领巾巡讲团人数 -->
        <div v-if="hasRedScarfGroup == 1">
          <van-field
            required
            v-model="redScarfGroupNum"
            clearable
            type="digit"
            label="本级红领巾巡讲团人数"
            placeholder="请输入人数"
            :rules="[{ required: true, message: '请输入本级红领巾巡讲团人数' },
              {
                validator: (val) => val >= 1 && val <= 400,
                message:
                  '本级红领巾巡讲团人数必须在1-400之间',
              },]"
            @blur="
              handleCountCheck('redScarfGroupNum', '本级红领巾巡讲团人数', 400)
            "
            class="fieldVertical"
          />
          <van-field
            required
            v-model="redScarfGroupNumConfirm"
            clearable
            type="digit"
            label="确认本级红领巾巡讲团人数"
            placeholder="请再次输入人数"
            :rules="[
              { required: true, message: '请再次输入本级红领巾巡讲团人数' },
              {
                validator: (val) => val === redScarfGroupNum,
                message: '本级红领巾巡讲团人数两次输入的人数不一致',
              },
            ]"
            class="fieldVertical"
          />
        </div>

        <!-- 3-3. 2025年度是否主办过少先队线下培训班 -->
        <van-field
          class="fieldVertical"
          required
          name="radio"
          label="本级团委、教育行政部门、少工委2025年度是否主办过少先队线下培训班（参与上级组织培训的不纳入）"
          :rules="[
            {
              required: true,
              message:
                '请选择本级团委、教育行政部门、少工委2025年度是否主办过少先队线下培训班',
            },
          ]"
        >
          <template #input>
            <van-radio-group v-model="hasTraining2025" direction="horizontal">
              <van-radio :name="1" checked-color="#ff6865">是</van-radio>
              <van-radio :name="2" checked-color="#ff6865">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>

        <!-- 3-4. 培训班数量及人数 -->
        <div v-if="hasTraining2025 == 1">
          <van-field
            class="fieldVertical"
            required
            v-model="trainingCount"
            name="trainingCount"
            clearable
            type="digit"
            label="本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数"
            placeholder="请输入个数"
            :rules="[
              {
                required: true,
                message:
                  '请输入本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数',
              },
              {
                validator: (val) => Number(val) >= 1 && Number(val) <= 20,
                message:
                  '本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数必须在1-20之间',
              },
            ]"
            @blur="
              handleCountCheck(
                'trainingCount',
                '本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数',
                20,
              )
            "
          />
          <van-field
            class="fieldVertical"
            required
            v-model="trainingCountConfirm"
            clearable
            type="digit"
            label="确认本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数"
            placeholder="请再次输入个数"
            :rules="[
              {
                required: true,
                message:
                  '请再次输入本级团委、教育行政部门、少工委2025年度主办少先队线下培训班个数',
              },
              {
                validator: (val) => Number(val) === Number(trainingCount),
                message:
                  '本级团委、教育行政部门、少工委2025年度主办少先队线下培训班两次输入的个数不一致',
              },
            ]"
          />

          <van-field
            class="fieldVertical"
            required
            v-model="traineeCount"
            name="traineeCount"
            clearable
            type="digit"
            label="参训人数"
            placeholder="请输入人数"
            :rules="[
              { required: true, message: '请输入人数' },
              {
                validator: (val) => Number(val) >= 1 && Number(val) <= 2000,
                message: '参训人数必须在1-2000之间',
              },
              {
                validator: (val) => Number(val) > Number(trainingCount),
                message: '参训人数必须大于培训班个数',
              },
              {
                validator: (val) => Number(val) >= traineeTypes.length,
                message: '参训人数必须大于或等于所选择的参训人员类型数量',
              },
            ]"
            @blur="handleCountCheck('traineeCount', '参训人数', 2000)"
          />
          <van-field
            class="fieldVertical"
            required
            v-model="traineeCountConfirm"
            clearable
            type="digit"
            label="确认参训人数"
            placeholder="请再次输入人数"
            :rules="[
              { required: true, message: '请再次输入人数' },
              {
                validator: (val) => Number(val) === Number(traineeCount),
                message: '两次输入的人数不一致',
              },
            ]"
          />

          <van-field
            class="fieldVertical"
            required
            name="checkboxGroup"
            label="参训人员类型"
            :rules="[{ required: true, message: '请选择参训人员类型' }]"
          >
            <template #input>
              <van-checkbox-group v-model="traineeTypes" direction="vertical">
                <van-checkbox
                  v-for="item in traineeTypeList"
                  :key="item.key"
                  :name="item.key"
                  shape="square"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
        </div>

        <template v-if="isEquippedCounselor == 1">
          <!-- 4-1. 全日制教育学历 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="全日制教育学历"
            :rules="[{ required: true, message: '请选择全日制教育学历' }]"
          >
            <template #input>
              <van-radio-group v-model="fullTimeEdu" direction="vertical">
                <van-radio
                  v-for="item in eduList01"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 4-2. 全日制所学专业大类 -->
          <diy-picker
            title="所学专业大类(全日制)"
            :value="fullTimeMajorTxt"
            :list="majorList"
            :handlerSelect="selectFullTimeMajor"
            :isClick="true"
            :isRequired="fullTimeMajorFlag"
          />
          <div style="font-size: 16px; color: #999; padding: 0 16px 10px">
            按所授予学位证书进行选择，若没有学位证书则按毕业证书上所学专业的大类来选择
          </div>

          <!-- 4-3. 继续教育学历 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="继续教育学历"
            :rules="[{ required: true, message: '请选择学历' }]"
          >
            <template #input>
              <van-radio-group v-model="continueEdu" direction="vertical">
                <van-radio :name="0" checked-color="#ff6865">未参加</van-radio>
                <van-radio
                  v-for="item in eduList01"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 4-4. 继续教育所学专业大类 -->
          <div v-if="continueEdu !== 0 && continueEdu !== null">
            <diy-picker
              title="所学专业大类(继续教育)"
              :value="continueMajorTxt"
              :list="majorList"
              :handlerSelect="selectContinueMajor"
              :isClick="true"
              :isRequired="continueMajorFlag"
            />
          </div>

          <!-- 5-1. 本人编制所在单位 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="本人编制所在单位"
            :rules="[{ required: true, message: '请选择本人编制所在单位' }]"
          >
            <template #input>
              <van-radio-group v-model="unitType" direction="vertical">
                <van-radio
                  v-for="item in organizationList"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 5-2. 团内职务 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="团内职务"
            :rules="[{ required: true, message: '请选择团内职务' }]"
          >
            <template #input>
              <van-radio-group v-model="leaguePosition" direction="vertical">
                <van-radio
                  v-for="item in tuanJobList"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 5-3. 本人编制类型 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="本人编制类型"
            :rules="[{ required: true, message: '请选择编制类型' }]"
          >
            <template #input>
              <van-radio-group v-model="establishmentType" direction="vertical">
                <van-radio
                  v-for="item in jobTypeList"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>

          <!-- 5-4. 行政（事业）级别 -->
          <van-field
            class="fieldVertical"
            required
            name="radio"
            label="行政（事业）级别"
            :rules="[{ required: true, message: '请选择行政（事业）级别' }]"
          >
            <template #input>
              <van-radio-group v-model="adminLevel" direction="vertical">
                <van-radio
                  v-for="item in jobLevList"
                  :key="item.key"
                  :name="item.key"
                  checked-color="#ff6865"
                >
                  {{ item.value }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div style="font-size: 16px; color: #999; padding: 0 16px 10px">
            *参公及事业单位人员参照此填写
          </div>
        </template>

          <!-- 6. 校外辅导员人数 (县级) -->
          <div v-if="fdyLevel == 3">
            <van-field
              class="fieldVertical"
              required
              v-model="offCampusCounselorNum"
              clearable
              type="digit"
              label="本县（市、区、旗）登记在册的校外辅导员人数"
              placeholder="请输入人数"
              :rules="[
                {
                  required: true,
                  message: '请输入本县（市、区、旗）登记在册的校外辅导员人数',
                },
                {
                  validator: (val) => val >= 0 && val <= 5000,
                  message:
                    '本县（市、区、旗）登记在册的校外辅导员人数必须在0-5000之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'offCampusCounselorNum',
                  '本县（市、区、旗）登记在册的校外辅导员人数',
                  5000,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="offCampusCounselorNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）登记在册的校外辅导员人数"
              placeholder="请再次输入人数"
              :rules="[
                {
                  required: true,
                  message: '请再次输入本县（市、区、旗）登记在册的校外辅导员人数',
                },
                {
                  validator: (val) => val === offCampusCounselorNum,
                  message:
                    '两次输入的本县（市、区、旗）登记在册的校外辅导员人数不一致',
                },
              ]"
            />
          </div>

          <!-- 7. 未建少工委学校数量 (县级) -->
          <div v-if="fdyLevel == 3">
            <van-field
              class="fieldVertical"
              required
              v-model="noTeamSchoolNum"
              clearable
              type="digit"
              label="本县（市、区、旗）未建立少先队组织的中小学校数量"
              placeholder="请输入数量"
              :rules="[
                {
                  required: true,
                  message:
                    '请输入本县（市、区、旗）未建立少先队组织的中小学校数量',
                },
                {
                  validator: (val) => val >= 0 && val <= 10,
                  message:
                    '本县（市、区、旗）未建立少先队组织的中小学校数量必须在0-10之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'noTeamSchoolNum',
                  '本县（市、区、旗）未建立少先队组织的中小学校数量',
                  10,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="noTeamSchoolNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）未建立少先队组织的中小学校数量"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message:
                    '请再次输入本县（市、区、旗）未建立少先队组织的中小学校数量',
                },
                {
                  validator: (val) => val === noTeamSchoolNum,
                  message:
                    '本县（市、区、旗）未建立少先队组织的中小学校数量两次输入的不一致',
                },
              ]"
            />
          </div>

          <!-- 8. 未建立学校少工委的中小学校数量 (县级) -->
          <div v-if="fdyLevel == 3">
            <van-field
              class="fieldVertical"
              required
              v-model="noSgwSchoolNum"
              clearable
              type="digit"
              label="本县（市、区、旗）未建立学校少工委的中小学校数量"
              placeholder="请输入数量"
              :rules="[
                {
                  required: true,
                  message:
                    '请输入本县（市、区、旗）未建立学校少工委的中小学校数量',
                },
                {
                  validator: (val) => val >= 0 && val <= 10,
                  message:
                    '本县（市、区、旗）未建立学校少工委的中小学校数量必须在0-10之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'noSgwSchoolNum',
                  '本县（市、区、旗）未建立学校少工委的中小学校数量',
                  10,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="noSgwSchoolNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）未建立学校少工委的中小学校数量"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message:
                    '请再次输入本县（市、区、旗）未建立学校少工委的中小学校数量',
                },
                {
                  validator: (val) => val === noSgwSchoolNum,
                  message:
                    '本县（市、区、旗）未建立学校少工委的中小学校数量两次输入的不一致',
                },
              ]"
            />
          </div>
       
        <!-- 9. 直管青少年宫数量 -->
        <van-field
          class="fieldVertical"
          required
          v-model="directYouthPalaceNum"
          clearable
          type="digit"
          label="由本级少工委直管的建有少先队组织的青少年宫数量"
          placeholder="请输入数量"
          :rules="[
            {
              required: true,
              message: '请输入由本级少工委直管的建有少先队组织的青少年宫数量',
            },
            {
              validator: (val) => Number(val) >= 0 && Number(val) <= 9,
              message: '由本级少工委直管的建有少先队组织的青少年宫数量必须在0-9之间',
            },
          ]"
          @blur="
            handleCountCheck(
              'directYouthPalaceNum',
              '由本级少工委直管的建有少先队组织的青少年宫数量',
              9,
            )
          "
        />
        <van-field
          class="fieldVertical"
          required
          v-model="directYouthPalaceNumConfirm"
          clearable
          type="digit"
          label="确认由本级少工委直管的建有少先队组织的青少年宫数量"
          placeholder="请再次输入数量"
          :rules="[
            {
              required: true,
              message:
                '请再次输入由本级少工委直管的建有少先队组织的青少年宫数量',
            },
            {
              validator: (val) => Number(val) === Number(directYouthPalaceNum),
              message:
                '由本级少工委直管的建有少先队组织的青少年宫数量两次输入的不一致',
            },
          ]"
        />

        <!-- 10-13. 街道/乡镇/社区/村少工委数量 -->
        <div v-if="fdyLevel == 3">
            <van-field
              class="fieldVertical"
              required
              v-model="streetSgwNum"
              clearable
              type="digit"
              label="本县（市、区、旗）建立的街道少工委数量"
              placeholder="请输入数量"
              :rules="[
                {
                  required: true,
                  message: '请输入本县（市、区、旗）建立的街道少工委数量',
                },
                {
                  validator: (val) => val >= 0 && val <= 55,
                  message: '本县（市、区、旗）建立的街道少工委数量必须 在0-55之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'streetSgwNum',
                  '本县（市、区、旗）建立的街道少工委数量',
                  55
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="streetSgwNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）建立的街道少工委数量"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message: '请再次输入本县（市、区、旗）建立的街道少工委数量',
                },
                {
                  validator: (val) => val === streetSgwNum,
                  message: '本县（市、区、旗）建立的街道少工委数量两次输入的不一致',
                },
              ]"
            />

            <van-field
              class="fieldVertical"
              required
              v-model="townSgwNum"
              clearable
              type="digit"
              label="本县（市、区、旗）建立的乡镇少工委数量"
              placeholder="请输入数量（没有填0）"
              :rules="[
                {
                  required: true,
                  message: '请输入本县（市、区、旗）建立的乡镇少工委数量',
                },
                 {
                  validator: (val) => val >= 0 && val <= 55,
                  message: '本县（市、区、旗）建立的乡镇少工委数量必须在0-55之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'townSgwNum',
                  '本县（市、区、旗）建立的乡镇少工委数量',
                  55,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="townSgwNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）建立的乡镇少工委数量"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message: '请再次输入本县（市、区、旗）建立的乡镇少工委数量',
                },
                {
                  validator: (val) => val === townSgwNum,
                  message: '本县（市、区、旗）建立的乡镇少工委数量两次输入的不一致',
                },
              ]"
            />

            <van-field
              class="fieldVertical"
              required
              v-model="communitySgwNum"
              clearable
              type="digit"
              label="本县（市、区、旗）建立的社区少工委数量"
              placeholder="请输入数量"
              :rules="[
                {
                  required: true,
                  message: '请输入本县（市、区、旗）建立的社区少工委数量',
                },
                {
                  validator: (val) => val >= 0 && val <= 1300,
                  message: '本县（市、区、旗）建立的社区少工委数量必须在0-1300之间',
                },
              ]"
              @blur="
                handleCountCheck(
                  'communitySgwNum',
                  '本县（市、区、旗）建立的社区少工委数量',
                  1300,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="communitySgwNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）建立的社区少工委数量"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message: '请再次输入本县（市、区、旗）建立的社区少工委数量',
                },
                {
                  validator: (val) => val === communitySgwNum,
                  message: '本县（市、区、旗）建立的社区少工委数量两次输入的不一致',
                },
              ]"
            />

            <van-field
              class="fieldVertical"
              required
              v-model="villageSgwNum"
              clearable
              type="digit"
              label="本县（市、区、旗）建立的村少工委数量"
              label-align="top"
              placeholder="请输入数量"
              :rules="[
                {
                  required: true,
                  message: '请输入本县（市、区、旗）建立的村少工委数量',
                },
                {
                validator: (val) => val >= 0 && val <= 550,
                message:
                  '本县（市、区、旗）建立的村少工委数量必须在0-550之间',
              },
              ]"
              @blur="
                handleCountCheck(
                  'villageSgwNum',
                  '本县（市、区、旗）建立的村少工委数量',
                  550,
                )
              "
            />
            <van-field
              class="fieldVertical"
              required
              v-model="villageSgwNumConfirm"
              clearable
              type="digit"
              label="确认本县（市、区、旗）建立的村少工委数量"
              label-align="top"
              placeholder="请再次输入数量"
              :rules="[
                {
                  required: true,
                  message: '请再次输入本县（市、区、旗）建立的村少工委数量',
                },
                {
                  validator: (val) => val === villageSgwNum,
                  message: '本县（市、区、旗）建立的村少工委数量两次输入的不一致',
                },
              ]"
            />
        </div>
        <!-- 14. 填表人信息 -->
        <div>
            <div class="section-title-1">填表人信息</div>
          <van-field
            class="fieldVertical"
            required
            v-model="fillerName"
            clearable
            label="填表人姓名"
            placeholder="请输入填表人姓名"
            :rules="[
              { required: true, message: '请输入填表人姓名' },
              { validator: validateName, label: '填表人姓名' },
            ]"
          />
          <van-field
            class="fieldVertical"
            required
            v-model="fillerNameConfirm"
            clearable
            label="确认填表人姓名"
            placeholder="请再次输入填表人姓名"
            :rules="[
              { required: true, message: '请再次输入填表人姓名' },
              {
                validator: (val) => val === fillerName,
                message: '两次输入的填表人姓名不一致',
              },
              { validator: validateName, label: '确认填表人姓名' },
            ]"
          />

          <van-field
            class="fieldVertical"
            required
            v-model="fillerTel"
            clearable
            label="填表人手机号"
            placeholder="请输入填表人手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请输入填表人手机号' },
              { pattern: /^1[3456789]\d{9}$/, message: '填表人手机号格式错误' },
            ]"
            @blur="handleDoubleCheck('fillerTel', '填表人手机号')"
          />
          <van-field
            class="fieldVertical"
            required
            v-model="fillerTelConfirm"
            clearable
            label="确认填表人手机号"
            placeholder="请再次输入手机号"
            maxlength="11"
            :rules="[
              { required: true, message: '请再次输入手机号' },
              {
                validator: (val) => val === fillerTel,
                message: '两次输入的填表人手机号不一致',
              },
            ]"
          />

          <van-field
            class="fieldVertical"
            required
            v-model="fillerJob"
            clearable
            label="填表人工作单位及职务"
            placeholder="请输入填表人工作单位及职务"
            :rules="[{ required: true, message: '请输入填表人工作单位及职务' }]"
          />
        </div>
      </div>
      <div style="margin: 16px">
        <van-button
          round
          block
          type="primary"
          native-type="submit"
          class="btn btn_dl"
          :loading="isSubmitting"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, onMounted, watch } from "vue";
import headers from "@/components/Header";
import diyPicker from "@/components/Select";
import { getsubmitData, addForm, editForm } from "@/service/form";
import { getAreaList } from "@/service/area";
import { useRoute, useRouter } from "vue-router";
import { Dialog, Toast, Uploader, ImagePreview } from "vant";
import { getKey, encrypt, rsaUtil, serverPublicKey, tipsMsg } from "@/common/js";
import {
  zzmmList01,
  fdyLevList,
  traineeTypeList,
  eduList01,
  majorList,
  organizationList,
  tuanJobList,
  jobTypeList,
  jobLevList,
} from "@/common/js/field";
export default {
  name: "form11",
  components: {
    headers,
    diyPicker,
    // datetimePicker,
    [Uploader.name]: Uploader,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const formRef = ref(null);
    const isSubmitting = ref(false); // 状态锁


    const state = reactive({
      isEquippedCounselor: null,
      // 1-1
      name: null,
      nameConfirm: null,
      // 1-2
      idCard: null,
      idCardConfirm: null,
      // 1-3
      sex: null,
      // 1-4
      birthday: null,
      birthdayFlag: false,
      age:"",
      // 1-5
      tel: null,
      telConfirm: null,
      // 1-6
      province: "不限",
      provinceCode: "",
      city: "不限",
      cityCode: "",
      district: "不限",
      districtCode: "",
      areaTxt: "请选择",
      areaList: [], // 需要加载行政区划
      areaCode: null,
      areaFlag: false,
      areaShow: false,
      areaData: {},
      areaColumns: [],
      proofFile: "/file/proof.docx",
      shuoming: "/file/2025年度队统填报说明.pdf",
      fujian1: "/file/附件1队统填报问答.pdf",
      fujian2: "/file/附件2队统后台使用手册.pdf",
      // 1-7
      zzmm: null,
      // 2-1
      fdyLevel: null,
      // 2-2
      fileList: [],
      // 2-3
      townCounselorNum: null,
      townCounselorNumConfirm: null,
      // 3-1
      hasRedScarfGroup: null,
      // 3-2
      redScarfGroupNum: null,
      redScarfGroupNumConfirm: null,
      // 3-3
      hasTraining2025: null,
      // 3-4
      trainingCount: null,
      trainingCountConfirm: null,
      traineeCount: null,
      traineeCountConfirm: null,
      traineeTypes: [],
      // 4-1
      fullTimeEdu: null,
      // 4-2
      fullTimeMajorTxt: "请选择",
      fullTimeMajor: null,
      fullTimeMajorFlag: false,
      // 4-3
      continueEdu: null,
      // 4-4
      continueMajorTxt: "请选择",
      continueMajor: null,
      continueMajorFlag: false,
      // 5-1
      unitType: null,
      // 5-2
      leaguePosition: null,
      // 5-3
      establishmentType: null,
      // 5-4
      adminLevel: null,
      // 6
      offCampusCounselorNum: null,
      offCampusCounselorNumConfirm: null,
      // 7
      noTeamSchoolNum: null,
      noTeamSchoolNumConfirm: null,
      // 8
      noSgwSchoolNum: null,
      noSgwSchoolNumConfirm: null,
      // 9
      directYouthPalaceNum: null,
      directYouthPalaceNumConfirm: null,
      // 10
      streetSgwNum: null,
      streetSgwNumConfirm: null,
      // 11
      townSgwNum: null,
      townSgwNumConfirm: null,
      // 12
      communitySgwNum: null,
      communitySgwNumConfirm: null,
      // 13
      villageSgwNum: null,
      villageSgwNumConfirm: null,
      // 14
      fillerName: null,
      fillerNameConfirm: null,
      fillerTel: null,
      fillerTelConfirm: null,
      fillerJob: null,
    });

    onMounted(() => {
      getAreaData();
      const { type, id } = route.query;
      if (type == 1 && id) {
        getInfo(id);
      }
    });

    const getAreaData = async () => {
      const { data, code } = await getAreaList();
      if (code === 10000) {
        state.areaData = data;
        initColumns();
      }
    };

    const initColumns = () => {
      const provinces = state.areaData["100000"] || {};
      const provinceList = Object.keys(provinces).map((key) => ({
        text: provinces[key],
        value: key,
      }));

      state.areaColumns = [
        { values: provinceList },
        { values: [] },
        { values: [] },
      ];

      if (provinceList.length > 0) {
        const firstProvinceCode = provinceList[0].value;
        updateCities(firstProvinceCode);
      }
    };

    const updateCities = (provinceCode) => {
      const citiesMap = state.areaData[provinceCode] || {};
      const cityList = Object.keys(citiesMap).map((key) => ({
        text: citiesMap[key],
        value: key,
      }));
      state.areaColumns[1].values = cityList;

      if (cityList.length > 0) {
        updateDistricts(cityList[0].value);
      } else {
        state.areaColumns[2].values = [];
      }
    };

    const updateDistricts = (cityCode) => {
      const districtsMap = state.areaData[cityCode] || {};
      const districtList = Object.keys(districtsMap).map((key) => ({
        text: districtsMap[key],
        value: key,
      }));
      state.areaColumns[2].values = districtList;
    };

    const onAreaChange = (value, index) => {
      const selectedOption = value[index];

      if (index === 0) {
        updateCities(selectedOption.value);
      } else if (index === 1) {
        updateDistricts(selectedOption.value);
      }
    };

    const onAreaConfirm = (values) => {
      const [prov, city, dist] = values;

      state.province = prov ? prov.text : "";
      state.provinceCode = prov ? prov.value : "";
      state.city = city ? city.text : "";
      state.cityCode = city ? city.value : "";
      state.district = dist ? dist.text : "";
      state.districtCode = dist ? dist.value : "";

      state.areaCode =
        state.districtCode || state.cityCode || state.provinceCode;

      const p = state.province === "不限" ? "" : state.province;
      const c = state.city === "不限" ? "" : state.city;
      const d = state.district === "不限" ? "" : state.district;

      if (!p && !c && !d) {
        state.areaTxt = "请选择";
      } else {
        state.areaTxt = `${p} ${c} ${d}`.trim();
      }
      console.log("state.areaTxt--", state.areaTxt);
      state.areaShow = false;
    };

    const showAreaPopup = () => {
      state.areaShow = true;
    };

    const getInfo = async (id) => {
      const result = await getsubmitData({ dataId: id });
      const { code, data } = result;
      if (code == 10000 && data) {
        for (const i of data.list) {
          const { fieldCode, value } = i;
          if (fieldCode === "traineeTypes") {
            // traineeTypes 存的是以逗号分隔的字符串，需要转换回数字数组
            state.traineeTypes = value ? value.split(",").map(Number) : [];
          } else if (fieldCode === "file") {
            state.fileList = [{ url: value }];
          } else if (fieldCode === "fullTimeMajor") {
            state.fullTimeMajor = value;
            const major = majorList.find((m) => m.key == value);
            if (major) state.fullTimeMajorTxt = major.value;
          } else if (fieldCode === "continueMajor") {
            state.continueMajor = value;
            const major = majorList.find((m) => m.key == value);
            if (major) state.continueMajorTxt = major.value;
          } else if (fieldCode === "birthday") {
            // 出生年月存的是秒级时间戳，DatePicker 组件已支持秒级回显
            state.birthday = value;
          } else {
            state[fieldCode] = value;
            // 填充确认字段
            if (Object.prototype.hasOwnProperty.call(state, fieldCode + "Confirm")) {
              state[fieldCode + "Confirm"] = value;
            }
          }
        }

        // 处理行政区划回显
        if (state.areaCode) {
          // 等待接口数据加载完成后处理
          const checkAreaData = setInterval(() => {
            if (Object.keys(state.areaData).length > 0) {
              clearInterval(checkAreaData);
              handleAreaEcho(state.areaCode);
            }
          }, 100);
        }
      }
    };

    const handleAreaEcho = (code) => {
      // 这里的逻辑需要根据 areaData 结构来反推省市区
      // 简单处理：先从 state.areaData 中查找
      let pCode = "",
        cCode = "",
        dCode = "";
      let pName = "",
        cName = "",
        dName = "";

      // 假设 areaCode 是 6 位，尝试匹配
      const provinces = state.areaData["100000"] || {};
      
      // 遍历省
      for (let p in provinces) {
        if (p === code) {
          pCode = p;
          pName = provinces[p];
          break;
        }
        const cities = state.areaData[p] || {};
        for (let c in cities) {
          if (c === code) {
            pCode = p;
            pName = provinces[p];
            cCode = c;
            cName = cities[c];
            break;
          }
          const districts = state.areaData[c] || {};
          for (let d in districts) {
            if (d === code) {
              pCode = p;
              pName = provinces[p];
              cCode = c;
              cName = cities[c];
              dCode = d;
              dName = districts[d];
              break;
            }
          }
          if (dCode) break;
        }
        if (cCode) break;
      }

      state.province = pName;
      state.provinceCode = pCode;
      state.city = cName;
      state.cityCode = cCode;
      state.district = dName;
      state.districtCode = dCode;

      const p = pName === "不限" ? "" : pName;
      const c = cName === "不限" ? "" : cName;
      const d = dName === "不限" ? "" : dName;

      if (!p && !c && !d) {
        state.areaTxt = "请选择";
      } else {
        state.areaTxt = `${p} ${c} ${d}`.trim();
      }
    };

    const goBack = () => {
      router.go(-1);
    };

    const handlerSelect = (key, value) => {
      state[key] = value;
      if (key == "birthday") {
        state.birthdayFlag = false;
        if (state.idCard && /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(state.idCard)) {
          const idBirthday = state.idCard.substring(6, 12); // YYYYMM
          const selectedDate = new Date(value * 1000);
          const year = selectedDate.getFullYear();
          let month = selectedDate.getMonth() + 1;
          month = month < 10 ? `0${month}` : month;
          if (`${year}${month}` !== idBirthday) {
            Toast.fail("所选出生年月与身份证号不符");
          }
        }
      }
    };

    const selectArea = (value) => {
      const { province, provinceCode, city, cityCode, district, districtCode } =
        value;
      state.province = province;
      state.provinceCode = provinceCode;
      state.city = city;
      state.cityCode = cityCode;
      state.district = district;
      state.districtCode = districtCode;

      // Update areaTxt for display or validation
      if (province && city && district && province !== "不限") {
        state.areaTxt = `${province} ${city !== "不限" ? city : ""} ${
          district !== "不限" ? district : ""
        }`;
        state.areaFlag = false;
      }
    };

    const selectFullTimeMajor = (key, value) => {
      state.fullTimeMajor = key;
      state.fullTimeMajorTxt = value;
      state.fullTimeMajorFlag = false;
    };

    const selectContinueMajor = (key, value) => {
      state.continueMajor = key;
      state.continueMajorTxt = value;
      state.continueMajorFlag = false;
    };

    const handleDoubleCheck = (field, label) => {
      const val = state[field];
      if (val === null || val === undefined) {
        return;
      }
      if (typeof val === "string" && val.trim() === "") {
        return;
      }
      Dialog.alert({
         title: "提示",
          message: `您填写的${label}为：${state[field]}，请在下方再次输入以确认。`,
      });
    };

    const handleCountCheck = (field, label, limit = null) => {
      if (state[field]) {
          let msg = `您填写的${label}为：${state[field]}，请在下方再次输入以确认。`;
          if (limit && Number(state[field]) > limit) {
            msg = `警示：您填写的${label}为：${state[field]}，数值超过了${limit}，请核实并再次输入以确认。`;
          }
          Dialog.alert({
            title: "提示",
            message: msg,
          });
        }
    };
    const handlePreview = (item) => {
      ImagePreview({
        images: [item.url || item.content],
        closeOnClickImage: true, // 明确开启此选项
        closeable: true, // 如果需要关闭图标
      });
    };
    const afterRead = async (file) => {
      file.status = "uploading";
      file.message = "上传中...";

      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("folder", "sxdsjtj");

      try {
        const response = await fetch("https://static.k618.cn/api/upload/", {
          method: "POST",
          body: formData,
        });
        const resData = await response.json();
        console.log("upload rest", resData);
        if (resData && resData.status == 0) {
          file.status = "done";
          file.url = resData.result[0].url;
        } else {
          file.status = "failed";
          file.message = "上传失败";
          Toast.fail(resData.message || "上传失败");
        }
      } catch (error) {
        console.log("upload error ", error);
        file.status = "failed";
        file.message = "上传失败";
        Toast.fail("上传失败");
        console.error(error);
      }
    };

    const onClickButtonSubmit = async () => {
      console.log("state.birthday -> ", state.birthday);
      if (isSubmitting.value) return; // 如果正在提交，直接拦截后续点击
      
      // Validate manual pickers
      if (state.isEquippedCounselor == 1) {
        if (!state.birthday) {
          Toast.fail("请选择出生年月");
          state.birthdayFlag = true;
          return;
        }
        if (state.fullTimeMajorTxt === "请选择") {
          Toast.fail("所学专业大类(全日制)");
          state.fullTimeMajorFlag = true;
          return;
        }
        if (
          state.continueEdu !== 0 &&
          state.continueEdu !== null &&
          state.continueMajorTxt === "请选择"
        ) {
          state.continueMajorFlag = true;
          Toast.fail("所学专业大类(继续教育)");
          return;
        }
      }
      if (state.areaTxt === "请选择") {
        Toast.fail("请选择行政区划");
        return;
      }

      let list = [];
      const add = (code, val) => list.push({ fieldCode: code, value: val });

      add("isEquippedCounselor", state.isEquippedCounselor);
      add("areaCode", state.areaCode);
      add("fdyLevel", state.fdyLevel);

      if (state.isEquippedCounselor == 1) {
        add("name", state.name);
        add("idCard", state.idCard);
        add("sex", state.sex);
        add("birthday", state.birthday);
        add("tel", state.tel);
        add("zzmm", state.zzmm);

        // Image
        if (state.fileList.length > 0) {
          add("file", state.fileList[0].url || state.fileList[0].content);
        }

        add("fullTimeEdu", state.fullTimeEdu);
        add("fullTimeMajor", state.fullTimeMajor);
        add("continueEdu", state.continueEdu);
        if (state.continueEdu !== 0) {
          add("continueMajor", state.continueMajor);
        }

        add("unitType", state.unitType);
        add("leaguePosition", state.leaguePosition);
        add("establishmentType", state.establishmentType);
        add("adminLevel", state.adminLevel);

      }

      if (state.fdyLevel == 3) {
          add("townCounselorNum", state.townCounselorNum);
          add("offCampusCounselorNum", state.offCampusCounselorNum);
          add("noTeamSchoolNum", state.noTeamSchoolNum);
          add("noSgwSchoolNum", state.noSgwSchoolNum);

          add("streetSgwNum", state.streetSgwNum);
          add("townSgwNum", state.townSgwNum);
          add("communitySgwNum", state.communitySgwNum);
          add("villageSgwNum", state.villageSgwNum);
      }

      add("hasRedScarfGroup", state.hasRedScarfGroup);
      if (state.hasRedScarfGroup == 1) {
        add("redScarfGroupNum", state.redScarfGroupNum);
      }

      add("hasTraining2025", state.hasTraining2025);
      if (state.hasTraining2025 == 1) {
        add("trainingCount", state.trainingCount);
        add("traineeCount", state.traineeCount);
        add("traineeTypes", state.traineeTypes.join(","));
      }

      add("directYouthPalaceNum", state.directYouthPalaceNum);

      add("fillerName", state.fillerName);
      add("fillerTel", state.fillerTel);
      add("fillerJob", state.fillerJob);

      isSubmitting.value = true;
      const toast = Toast.loading({
        message: "提交中...",
        forbidClick: true, // 核心：禁止背景点击
        duration: 0,
      });


      const params = {
        list,
        formId: 40,
      };
      const { type, id } = route.query;
      let res;

      if (type == 1) {
          params.id = id;
      }
      //随机获取AES的key
      let aesKey = getKey().toLowerCase();
      let param = {
        encryptData: encrypt(params, aesKey), //AES加密后的数据
        encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
      };
      try {
        if (type == 1) {
          res = await editForm(param);
        } else {
          res = await addForm(param);
        }
        console.log("params -> ", params);
        if (res.code === 10000) {
          // proxy.$closeLoading();
          Dialog.alert({
            message: "提交成功",
          }).then(() => {
            router.go(-1);
          });
        } else {
          Toast.fail(res.msg || "提交失败");
           isSubmitting.value = false;
          // proxy.$closeLoading();
        }
      } catch (error) {
        // proxy.$closeLoading();
        Toast.fail(res.msg || "提交失败");
        console.log("res error -> ", error);
        isSubmitting.value = false;
      } finally {
        toast.clear();
      }
    };

    const validateName = (val, rule) => {
      if (!val) return true;
      const label = rule.label || "姓名";
      // const nameReg = /^[\u4e00-\u9fa5·]+$/;
      const nameReg = /^[\p{Unified_Ideograph}]+(?:·[\p{Unified_Ideograph}]+)*$/u;
      if (!nameReg.test(val)) {
        return `${label}只能输入汉字和间隔号“·”，且不能以“·”开始或结尾`;
      }
      if (val.length < 1 || val.length > 12) {
        return `${label}字数需在1到12个字之间`;
      }
      return true;
    };

    const handleFailed = (errorInfo) => {
      console.log("failed", errorInfo);
      if (errorInfo && errorInfo.errors.length > 0) {
        tipsMsg("提示", errorInfo.errors[0].message, () => {
          formRef.value.scrollToField(errorInfo.errors[0].name);
        });
      }
    };

    watch(
      () => state.idCard,
      (val) => {
        if (
          val &&
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
            val,
          )
        ) {
          const birthYear = val.substring(6, 10);
          const birthMonth = val.substring(10, 12);
          const birthDay = val.substring(12, 14);
          // const birthdayDate = new Date(`${year}-${month}-${day}`);
          // state.birthday = Math.floor(birthdayDate.getTime() / 1000);
          // 按照 2025 年 12 月 31 日结算年龄
          let ageValue = 2025 - birthYear;
          if (birthMonth > 12 || (birthMonth === 12 && birthDay > 31)) {
            ageValue--;
          }
          state.age = ageValue;
          state.birthday = ageValue; // 保持后端 birthday 字段同步

          // 自动回显性别
          const sexCode = val.substring(16, 17);
          state.sex = parseInt(sexCode) % 2 === 0 ? 2 : 1; // 2为女, 1为男
        }
      },
    );

    watch(
            () => state.fdyLevel,
            (val) =>{
              //清空聘书或任命文件
              if(val == 1){
                state.fileList = [];
              }
              //清空非区县级时的表单项
              if(val != 3){
                state.townCounselorNum = null;
                state.townCounselorNumConfirm = null;
                state.offCampusCounselorNum = null;
                state.offCampusCounselorNumConfirm = null;
                state.noTeamSchoolNum = null;
                state.noTeamSchoolNumConfirm = null;
                state.noSgwSchoolNum = null;
                state.noSgwSchoolNumConfirm = null;
              }
            },
    );

    watch(
      () => state.trainingCount,
      () => {
        if (state.hasTraining2025 == 1 && state.traineeCount) {
          formRef.value.validate('traineeCount');
        }
      },
    );

    watch(
      () => state.traineeTypes,
      () => {
        if (state.hasTraining2025 == 1 && state.traineeCount) {
          formRef.value.validate('traineeCount');
        }
      },
      { deep: true },
    );

    return {
      state,
      ...toRefs(state),
      formRef,
      goBack,
      onClickButtonSubmit,
      handleFailed,
      validateName,
      handlerSelect,
      selectArea,
      selectFullTimeMajor,
      selectContinueMajor,
      handleDoubleCheck,
      handleCountCheck,
      handlePreview,
      afterRead,
      showAreaPopup,
      onAreaConfirm,
      onAreaChange,
      zzmmList01,
      fdyLevList,
      traineeTypeList,
      eduList01,
      majorList,
      organizationList,
      tuanJobList,
      jobTypeList,
      jobLevList,
    };
  },
};
</script>

<style scoped lang="less">
.go_back {
  height: 0.383rem;
  padding: 0.033rem 0 0 0.333rem;
  overflow: visible;
  color: rgb(255, 255, 255);
  font-size: 28px;
  z-index: 99;
}
.custom-cell-title {
  font-weight: bold;
  font-size: 16px;
}
:deep(.van-field__control--custom) {
  display: block;
}
.radioFlex :deep(.van-field__control--custom) {
  display: flex;
}
:deep(.van-cell__value),
:deep(.van-field__control),
:deep(.van-cell__right-icon) {
  color: #ff6865;
}
:deep(.van-radio--vertical),
:deep(.van-checkbox) {
  margin-bottom: 0.08rem !important;
}
:deep(.van-radio__icon .van-icon),
:deep(.van-checkbox__icon .van-icon) {
  border: 0.02667rem solid #ff6865 !important;
}
:deep(.van-cell__title) {
  color: #646566;
}
:deep(.van-radio-group) {
  padding: 0.168rem 0;
}
.title {
  text-align: center;
  font-size: 17px;
  margin-top: 10px;
  .tip {
    font-size: 12px;
  }
}
.fieldVertical {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.fieldVertical :deep(.van-cell__value),
.fieldVertical :deep(.van-field__control) {
  width: 100%;
}
.fieldVertical :deep(.van-cell__title) {
  width: 100%;
  flex: none;
  margin-bottom: 4px;
  white-space: normal;
}

.official-document {
    // font-family: "FangSong", "仿宋", serif; /* 公文标准字体 */
    line-height: 1.5; /* 行间距 */
    text-align: justify; /* 两端对齐，使排版更整齐 */
    max-width: 800px; /* 根据实际页面需求调整宽度 */
    padding: 15px;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    margin: 10px;
    border-radius: 4px;
    font-size: 16px;
  }

  .official-heading {
    font-weight: bold;
    margin-bottom: 10px;
    color: #faad14;
    text-indent: 2em; 
  }

  .official-paragraph {
    text-indent: 2em; /* 核心：首行缩进2字符 */
    margin-top: 10px; /* 段落间距 */
    font-size: 16px;
  }
.section-title-1{
  padding: 15px 17px;
  color: #646566;
  font-size: 14px;
  background: #fdfdfd;
  border-bottom: 1px solid #eee;
}
</style>
